// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1hC0T","requiredAsterisk":"Info_requiredAsterisk__11LUX"};